import { render, staticRenderFns } from "./TabHistory.vue?vue&type=template&id=f4855902"
import script from "./TabHistory.vue?vue&type=script&lang=ts"
export * from "./TabHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports